import { Button, Card, Divider } from "antd";
import "../../style/component.css"
import AttendanceCard from "../../pages/staffModule/dashboard/AttendanceCard";
import LockLogo from "../../assets/png/dark-lock.png"
import { LogOut } from "lucide-react";
import { useAuth } from "../../context/authContext";
import Headers from "../header/Header";
import { useEffect } from "react";

const AttendanceLock = () => {
    const { logoutStaffParent } = useAuth()
    const handleLogout = () => {
        logoutStaffParent()
    }
    useEffect(() => {
        const handler = (e) => {
            if (
                e.key === "F12" ||
                (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key)) ||
                (e.ctrlKey && ["U", "S"].includes(e.key))
            ) {
                e.preventDefault();
            }
        };

        document.addEventListener("keydown", handler);
        return () => document.removeEventListener("keydown", handler);
    }, []);
    useEffect(() => {
  const handler = (e) => e.preventDefault();
  document.addEventListener("contextmenu", handler);

  return () => document.removeEventListener("contextmenu", handler);
}, []);
    return (
        <section className="wrapper-lock-overlay">
            <Headers />
            <div className="lock-overlay">
                <div className="lock-card">
                    <AttendanceCard />
                    <div className="lock-circle">
                        <img src={LockLogo} />
                        <p>Clock in to Use all the functions</p>
                        <Divider>
                            <Button onClick={handleLogout} shape="round" type="primary" danger icon={<LogOut size={16} />}>Logout</Button>
                        </Divider>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default AttendanceLock;
